module.exports = __webpack_public_path__ + "static/media/financepic3@2x.526fda0b.png";